module.exports = __webpack_public_path__ + "static/media/mm.bf265498.svg";